//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Menu from "./Footer/Menu";
//Install
import Social from "./Footer/Social";
//Install
import Copyright from "./Footer/Copyright";
//Install
import Corporation from "./Footer/Corporation";

//Element
class Footer extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("footer", { className: "S6pt64 C96Q4r pEO064 a527eB u3v98z" },
            //Element
            React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB p943pc" },
                //Element
                React.createElement(Container, {},
                    //Element
                    React.createElement(Row, {},
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i59n11" },
                                //Element
                                React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB o352hu" },
                                    //Element
                                    "Kurumsal Bilgilendirme"
                                ),
                                //Element
                                React.createElement(Corporation, {})
                            )
                        ),
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i59n11" },
                                //Element
                                React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB o352hu" },
                                    //Element
                                    "Sunulan Hizmetler"
                                ),
                                //Element
                                React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB rj401n" },
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/aydinlatma" },
                                            //Element
                                            "Aydınlatma"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/pano-imalati" },
                                            //Element
                                            "Pano İmalat"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/elektrik-taahhut" },
                                            //Element
                                            "Elektrik Taahhüt"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/yenilenebilir-enerji" },
                                            //Element
                                            "Yenilenebilir Enerji"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/orta-gerilim-tesisleri" },
                                            //Element
                                            "Orta Gerilim Tesisleri"
                                        )
                                    )
                                )
                            )
                        ),
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i59n11" },
                                //Element
                                React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB o352hu" },
                                    //Element
                                    "Kimlere Hizmet Sunuldu?"
                                ),
                                //Element
                                React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB rj401n" },
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/projeler" },
                                            //Element
                                            "Borusan"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/projeler" },
                                            //Element
                                            "Kanyon"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/projeler" },
                                            //Element
                                            "Arçelik"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/projeler" },
                                            //Element
                                            "Vestel"
                                        )
                                    ),
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/projeler" },
                                            //Element
                                            "Eczacıbaşı"
                                        )
                                    )
                                )
                            )
                        ),
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i59n11" },
                                //Element
                                React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB o352hu" },
                                    //Element
                                    "İletişim Bilgileri"
                                ),
                                //Element
                                React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB rj401n" },
                                    //Element
                                    React.createElement("li", { className: "S6pt64 C96Q4r" },
                                        //Element
                                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/iletisim" },
                                            //Element
                                            "İletişim"
                                        )
                                    )
                                )
                            )
                        ),
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i59n11" },
                                //Element
                                React.createElement("h6", { className: "S6pt64 C96Q4r pEO064 a527eB o352hu" },
                                    //Element
                                    "Hemen Takip Edin"
                                ),
                                //Element
                                React.createElement(Social, {})
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB g3i234" },
                //Element
                React.createElement(Container, {},
                    //Element
                    React.createElement(Row, {},
                        //Element
                        React.createElement(Col, { md: 8 },
                            //Element
                            React.createElement(Copyright, { ID: "0", Title: "Telif Hakkı © 2025 Temas Elektrik Taahhüt Limited Şirketi" })
                        ),
                        //Element
                        React.createElement(Col, { md: 4 },
                            //Element
                            React.createElement(Menu, {})
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Footer;